import { apiClient } from './client';

export interface Signature {
  id: string;
  fullName: string;
  title: string;
  email: string;
  phone: string | null;
  photoUrl: string | null;
  vimeoUrl: string | null;
  linkedinUrl: string | null;
  crunchbaseUrl: string | null;
  websiteUrl: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSignatureData {
  fullName: string;
  title: string;
  email: string;
  phone?: string;
  photoUrl?: string;
  vimeoUrl?: string;
  linkedinUrl?: string;
  crunchbaseUrl?: string;
  websiteUrl?: string;
}

export type UpdateSignatureData = Partial<CreateSignatureData>;

export async function getSignatures(): Promise<{ signatures: Signature[] }> {
  return apiClient.get('/signatures');
}

export async function getSignature(id: string): Promise<{ signature: Signature }> {
  return apiClient.get(`/signatures/${id}`);
}

export async function createSignature(data: CreateSignatureData): Promise<{ signature: Signature }> {
  return apiClient.post('/signatures', data);
}

export async function updateSignature(id: string, data: UpdateSignatureData): Promise<{ signature: Signature }> {
  return apiClient.patch(`/signatures/${id}`, data);
}

export async function deleteSignature(id: string): Promise<{ signature: Signature }> {
  return apiClient.delete(`/signatures/${id}`);
}

export async function uploadSignaturePhoto(id: string, file: File): Promise<{ signature: Signature }> {
  const formData = new FormData();
  formData.append('photo', file);

  const headers: Record<string, string> = {};
  const csrfToken = apiClient.getCsrfToken();
  if (csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
  }

  const response = await fetch(`/api/signatures/${id}/upload-photo`, {
    method: 'POST',
    headers,
    body: formData,
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: { message: 'Upload failed' } }));
    throw new Error(error.error?.message ?? 'Upload failed');
  }

  return response.json();
}
